import { render, staticRenderFns } from "./NoContentAssembleia.vue?vue&type=template&id=a63043f6&"
import script from "./NoContentAssembleia.vue?vue&type=script&lang=js&"
export * from "./NoContentAssembleia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports